import { cn } from "@/lib/utils";
import { type FC, Fragment } from "react";
import { MdCheck } from "react-icons/md";

export type Step = 1 | 2 | 3;

const STEPS = [
  { step: 1, label: "新規登録" },
  { step: 2, label: "メール認証" },
  { step: 3, label: "本人確認" },
] as const satisfies readonly { step: Step; label: string }[];

const StepCircle: FC<{
  step: Step;
  currentStep: Step;
}> = ({ step, currentStep }) => {
  const isCompleted = step < currentStep;
  const isActive = step === currentStep;

  return (
    <div
      className={cn(
        "flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold",
        isCompleted && "bg-primary-1 text-primary-6",
        isActive && "bg-primary-6 text-white",
        !isCompleted && !isActive && "bg-monotone-2 text-monotone-7",
      )}
    >
      {isCompleted ? <MdCheck className="h-5 w-5" /> : step}
    </div>
  );
};

const StepConnector: FC = () => (
  <div className="mx-8 h-0.5 w-4 bg-monotone-3 sm:mx-12" />
);

export const SignupStepBar: FC<{ currentStep: Step }> = ({ currentStep }) => {
  return (
    <div className="flex items-center justify-center">
      {STEPS.map(({ step, label }, index) => {
        const isCompleted = step < currentStep;
        const isActive = step === currentStep;
        return (
          <Fragment key={step}>
            <div className="flex flex-col items-center gap-1">
              <StepCircle step={step} currentStep={currentStep} />
              <span
                className={cn(
                  "text-xs font-bold",
                  (isCompleted || isActive) && "text-primary-6",
                  !isCompleted && !isActive && "text-monotone-7",
                )}
              >
                {label}
              </span>
            </div>
            {index < STEPS.length - 1 && <StepConnector />}
          </Fragment>
        );
      })}
    </div>
  );
};
